<template>
  <div v-uac="menuItem.code" class="item" :class="{ 'has-child': menuItem.children && menuItem.children.length, expand: expand }" @click="handleClick">
    <div class="inner" :class="{ active: menuItem.code === currentCode, 'child-selected': childSelected }">
      <div class="item-icon">
        <i v-if="menuItem.icon" :class="menuItem.icon" />
        <i v-else class="crm-icon-dot"></i>
      </div>
      <div class="menu-title">{{ menuItem.name }}</div>
      <div ref="circleDom" class="click-circle-zoom"></div>
    </div>
    <div v-if="menuItem.children && menuItem.children.length" :class="`sub-${deep}`">
      <menu-item v-for="menu in menuItem.children" :menu-item="menu" :key="menu.code" :deep="deep+1" :current-code="currentCode" @switch="handleSwitch" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'MenuItem',
  props: {
    menuItem: {
      type: Object,
      required: false,
      default () {
        return {
          code: '_default',
          name: '工作台',
          meta: '',
          url: '',
          clickHandler (ev) {
            ev.preventDefault()
          },
          icon: 'crm-icon-dashboard'
        }
      }
    },
    deep: {
      type: Number,
      default () {
        return 1
      }
    },
    currentCode: {
      type: String,
      default () {
        return 'm.home'
      }
    }
  },
  computed: {
    childSelected () {
      if (this.currentCode.indexOf(this.menuItem.code) === 0 && this.currentCode !== this.menuItem.code) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      expand: false
    }
  },
  methods: {
    handleClick (ev) {
      const { offsetX, offsetY } = ev
      const isSupported = window.CSS && window.CSS.supports && window.CSS.supports('--a', 0)
      if (isSupported) {
        this.$refs.circleDom.style.setProperty('--clickx', offsetX + 'px')
        this.$refs.circleDom.style.setProperty('--clicky', offsetY + 'px')
      }
      if (this.menuItem.children && this.menuItem.children.length) {
        this.expand = !this.expand
      } else {
        if (this.menuItem.code) {
          this.doSwitch(this.menuItem.code)
        }
      }
      if (this.menuItem.clickHandler && this.menuItem.clickHandler instanceof Function) {
        this.menuItem.clickHandler(ev)
      }
    },
    handleSwitch (code) {
      this.doSwitch(code)
    },
    doSwitch (code) {
      this.$emit('switch', code)
    }
  }
}
</script>
